// src/navigationSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const relatedFieldsSlice = createSlice({
  name: "relatedFields",
  initialState,
  reducers: {
    updaterelatedFields: (state, action) => {
      return { ...action.payload };
    },
    updateRelatedFieldsByParam: (state, action) => {
      const { paramName, value } = action.payload;
      return {
        ...state,
        [paramName]: value,
      };
    },
    resetrelatedFields: (state, action) => {
      return initialState; // Reset to initial stat
    },
  },
});

export const {
  updaterelatedFields,
  resetrelatedFields,
  updateRelatedFieldsByParam,
} = relatedFieldsSlice.actions;

export default relatedFieldsSlice.reducer;
